import { render } from "./gWattMinModal.vue?vue&type=template&id=59112cb0&ts=true"
import script from "./gWattMinModal.vue?vue&type=script&lang=ts"
export * from "./gWattMinModal.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__